import { Link } from "gatsby"
import React from "react"
import styled from "styled-components"

import Container from "$components/Container"
import Footer from "$components/Footer"
import Header from "$components/Header"
import SEO from "$components/SEO"

const H1 = styled.h1`
  color: ${props => props.theme.nero};
  font-size: 2rem;
`

const H2 = styled.h2`
  font-size: 1.5rem;
`

const Li = styled.li`
  font-family: ${props => props.theme.fontSecondary};
`

const P = styled.p`
  font-size: 1.1rem;
  text-align: left;
`

const Ul = styled.ul`
  margin: 0 auto;
  width: 70%;
`

export default () => (
  <>
    <SEO noindex title="Privacy Policy | Lotus Network Solutions" />
    <Header />
    <main>
      <Container>
        <H1>Privacy Policy</H1>

        <P>
          At Lotus Network Solutions, accessible from{" "}
          <Link to="/">https://lns.net.au</Link>, one of our main priorities is
          the privacy of our visitors. This Privacy Policy document contains
          types of information that is collected and recorded by Lotus Network
          Solutions and how we use it.
        </P>

        <P>
          If you have additional questions or require more information about our
          Privacy Policy, do not hesitate to contact us.
        </P>

        <P>
          This Privacy Policy applies only to our online activities and is valid
          for visitors to our website with regards to the information that they
          shared and/or collect in Lotus Network Solutions. This policy is not
          applicable to any information collected offline or via channels other
          than this website.
        </P>

        <H2>Consent</H2>

        <P>
          By using our website, you hereby consent to our Privacy Policy and
          agree to its terms.
        </P>

        <H2>Information we collect</H2>

        <P>
          The personal information that you are asked to provide, and the
          reasons why you are asked to provide it, will be made clear to you at
          the point we ask you to provide your personal information.
        </P>
        <P>
          If you contact us directly, we may receive additional information
          about you such as your name, email address, phone number, the contents
          of the message and/or attachments you may send us, and any other
          information you may choose to provide.
        </P>

        <H2>How we use your information</H2>

        <P>We use the information we collect in various ways, including to:</P>

        <Ul>
          <Li>Provide, operate, and maintain our website</Li>
          <Li>Improve, personalise, and expand our website</Li>
          <Li>Understand and analyse how you use our website</Li>
          <Li>Develop new products, services, features, and functionality</Li>
          <Li>
            Communicate with you, either directly or through one of our
            partners, including for customer service, to provide you with
            updates and other information relating to the website, and for
            marketing and promotional purposes
          </Li>
          <Li>Send you emails</Li>
          <Li>Find and prevent fraud</Li>
        </Ul>

        <H2>Log Files</H2>

        <P>
          Lotus Network Solutions follows a standard procedure of using log
          files. These files log visitors when they visit websites. All hosting
          companies do this and a part of hosting services' analytics. The
          information collected by log files include internet protocol (IP)
          addresses, browser type, Internet Service Provider (ISP), date and
          time stamp, referring/exit pages, and possibly the number of clicks.
          These are not linked to any information that is personally
          identifiable. The purpose of the information is for analysing trends,
          administering the site, tracking users' movement on the website, and
          gathering demographic information.
        </P>

        <H2>Cookies and Web Beacons</H2>

        <P>
          Like many other websites, Lotus Network Solutions uses 'cookies'.
          These cookies are used to store information including visitors'
          preferences, and the pages on the website that the visitor accessed or
          visited. The information is used to optimise the users' experience by
          customising our web page content based on visitors' browser type
          and/or other information.
        </P>

        <P>
          For more general information on cookies, please read{" "}
          <a
            href="https://www.cookieconsent.com/what-are-cookies/"
            rel="noopener noreferrer"
          >
            "What Are Cookies"
          </a>
          .
        </P>

        <P>
          You can choose to disable cookies through your individual browser
          options. More detailed information about cookie management with
          specific web browsers can be found at the browsers' respective
          websites.
        </P>

        <H2>Third Party Privacy Policies</H2>

        <P>
          Lotus Network Solutions's Privacy Policy does not apply to other
          advertisers or websites. Thus, we are advising you to consult the
          respective Privacy Policies of these third-party ad servers for more
          detailed information. It may include their practices and instructions
          about how to opt-out of certain options.
        </P>

        <P>
          Lotus Network Solutions uses Google Analytics to improve its services
          and the user experience by collecting data on how users interact with
          the site. Google's Privacy Policy regarding Google Analytics can be
          found at{" "}
          <a
            href="https://policies.google.com/technologies/partner-sites"
            rel="noopener noreferrer"
          >
            How Google uses data when you use our partners' sites or apps
          </a>
          .
        </P>

        <H2>CCPA Privacy Rights (Do Not Sell My Personal Information)</H2>

        <P>
          Under the CCPA, among other rights, California consumers have the
          right to:
        </P>
        <P>
          Request that a business that collects a consumer's personal data
          disclose the categories and specific pieces of personal data that a
          business has collected about consumers.
        </P>
        <P>
          Request that a business delete any personal data about the consumer
          that a business has collected.
        </P>
        <P>
          Request that a business that sells a consumer's personal data, not
          sell the consumer's personal data.
        </P>
        <P>
          If you make a request, we have one month to respond to you. If you
          would like to exercise any of these rights, please contact us.
        </P>

        <H2>GDPR Data Protection Rights</H2>

        <P>
          We would like to make sure you are fully aware of all of your data
          protection rights. Every user is entitled to the following:
        </P>
        <P>
          The right to access – You have the right to request copies of your
          personal data. We may charge you a small fee for this service.
        </P>
        <P>
          The right to rectification – You have the right to request that we
          correct any information you believe is inaccurate. You also have the
          right to request that we complete the information you believe is
          incomplete.
        </P>
        <P>
          The right to erasure – You have the right to request that we erase
          your personal data, under certain conditions.
        </P>
        <P>
          The right to restrict processing – You have the right to request that
          we restrict the processing of your personal data, under certain
          conditions.
        </P>
        <P>
          The right to object to processing – You have the right to object to
          our processing of your personal data, under certain conditions.
        </P>
        <P>
          The right to data portability – You have the right to request that we
          transfer the data that we have collected to another organisation, or
          directly to you, under certain conditions.
        </P>
        <P>
          If you make a request, we have one month to respond to you. If you
          would like to exercise any of these rights, please contact us.
        </P>

        <H2>Children's Information</H2>

        <P>
          Another part of our priority is adding protection for children while
          using the internet. We encourage parents and guardians to observe,
          participate in, and/or monitor and guide their online activity.
        </P>

        <P>
          Lotus Network Solutions does not knowingly collect any Personal
          Identifiable Information from children under the age of 13. If you
          think that your child provided this kind of information on our
          website, we strongly encourage you to contact us immediately and we
          will do our best efforts to promptly remove such information from our
          records.
        </P>
      </Container>
    </main>
    <Footer />
  </>
)

// Source

// Our Privacy Policy was created with the help of the <a href="https://www.privacypolicygenerator.info">  Privacy Policy Generator</a> and the <a href="https://www.privacypolicytemplate.net/">  Privacy Policy Template</a>.
